import BulbIcon from '@elementor/icons/BulbIcon';
import AccordionActions from '@elementor/ui/AccordionActions';
import Box from '@elementor/ui/Box';
import Typography from '@elementor/ui/Typography';
import { styled } from '@elementor/ui/styles';
import infoTipThumbnail from '@assets/image/thumb-alternative-text.png';
import infoTipVideoSrc from '@assets/video/alternative-text.webm';
import FixButton from '@components/fix-button';
import GetFreeInfoTip from '@components/get-free-info-tip';
import ArrowRightIcon from '@images/arrow-right-icon';
import { StyledAlert, StyledAlertTitle } from '@styles/app.styles';
import {
	StyledAccordionDetails,
	StyledFrame,
	StyledFrameText,
	StyledIssueResolveHeading,
} from '@styles/manual-fixes.styles';
import { scannerItem } from '@types/scanner-item';
import { __ } from '@utils/i18n';
import { injectTemplateVars } from '@utils/inject-template-vars';
import ImagePreview from './image-preview';

const AltTextForm = ({ item }) => {
	return (
		<>
			<StyledAccordionDetails>
				<Box>
					<Typography variant="subtitle2" as="h5">
						{__('What’s the issue?')}
					</Typography>

					<Typography variant="body2" color="secondary">
						{__(
							'This image doesn’t have alt text, so screen readers can’t describe it to users.',
						)}
					</Typography>
				</Box>

				<StyledPreview element={item.node} />

				<Box>
					<StyledIssueResolveHeading variant="subtitle2" as="h5">
						<BulbIcon fontSize="small" />

						{__('How to resolve')}
					</StyledIssueResolveHeading>

					<StyledFrame>
						<StyledFrameText variant="body2">
							<ArrowRightIcon />

							<Typography as="span" variant="body2">
								{injectTemplateVars(
									__(
										'Add a {{b}}description{{/b}}, or use empty alt text ("") for decorative images.',
									),
									{
										b: ({ children }) => <b>{children}</b>,
									},
								)}
							</Typography>
						</StyledFrameText>

						<StyledAlert color="info" sx={{ p: 1.5 }} icon={false}>
							<StyledAlertTitle>
								{injectTemplateVars(
									__(
										"{{b}}Tips{{/b}}: Keep descriptions short and simple, describing what the image shows or why it's on the page.",
									),
									{
										b: ({ children }) => <b>{children}</b>,
									},
								)}
							</StyledAlertTitle>
						</StyledAlert>
					</StyledFrame>
				</Box>
			</StyledAccordionDetails>

			<AccordionActions sx={{ pt: 1, pb: 3 }}>
				<FixButton
					infoTipContent={
						<GetFreeInfoTip
							videoSrc={infoTipVideoSrc}
							posterSrc={infoTipThumbnail}
							title={__('Add meaningful alt text with Ally')}
							description={__(
								'Get ready-to-use image descriptions generated for you automatically.',
							)}
						/>
					}
				/>
			</AccordionActions>
		</>
	);
};

export const StyledPreview = styled(ImagePreview)`
	width: 64px;
	height: 40px;
	border-radius: 4px;
	border: 1px solid rgba(0, 0, 0, 0.12);
`;

AltTextForm.propTypes = {
	item: scannerItem,
};

export default AltTextForm;
